var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _ProductForm_instances, announceAdded_fn, hideErrorNotification_fn, setLiveRegionText_fn, clearLiveRegionText_fn, fetchCartJson_fn;
import { C as Component } from "./component-cLJ9vlHA.js";
import { f as fetchConfig } from "./utilities-2Suih3Nm.js";
import { C as CustomEvents, c as CartAddEvent, T as ThemeAlertOpenEvent } from "./events-DeC3n8dp.js";
import "./critical-Da0Dmhh9.js";
class ProductForm extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductForm_instances);
    __publicField(this, "requiredRefs", ["liveRegion"]);
    __publicField(this, "handleVariantPickerSelected", (event) => {
      var _a, _b;
      if (((_b = (_a = event.detail) == null ? void 0 : _a.data) == null ? void 0 : _b.productId) && event.detail.data.productId !== this.dataset.productId) return;
      const { addToCartButton } = this.refs;
      if (addToCartButton) {
        addToCartButton.setAttribute("disabled", "true");
        addToCartButton.setAttribute("loading", "true");
      }
      const buyButtons = this.querySelectorAll('.shopify-payment-button__button, [data-testid="Checkout-button"]');
      buyButtons.forEach((btn) => {
        if (addToCartButton) {
          const loader = addToCartButton.querySelector(".button-loader-wrap");
          if (loader && !btn.querySelector(".button-loader-wrap")) {
            btn.appendChild(loader.cloneNode(true));
          }
        }
        btn.setAttribute("disabled", "true");
        btn.setAttribute("loading", "true");
      });
    });
    __publicField(this, "handleVariantPickerUpdate", (event) => {
      if (event.detail.data.productId !== this.dataset.productId) return;
      const newProductForm = event.detail.data.html.querySelector('product-form[id="' + this.id + '"]');
      if (!newProductForm) return;
      this.updateProductForm(newProductForm);
    });
  }
  get quickViewDialog() {
    return document.querySelector("quick-view-dialog");
  }
  get searchDrawer() {
    return document.querySelector("custom-dialog#SearchDrawer");
  }
  get cartMain() {
    return document.querySelector("cart-main");
  }
  connectedCallback() {
    super.connectedCallback();
    this.section = this.closest(".shopify-section, quick-view-dialog");
    if (!this.section) return;
    this.section.addEventListener(CustomEvents.variantPickerUpdate, this.handleVariantPickerUpdate);
    this.section.addEventListener(CustomEvents.variantPickerSelected, this.handleVariantPickerSelected);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (!this.section) return;
    this.section.removeEventListener(CustomEvents.variantPickerUpdate, this.handleVariantPickerUpdate);
    this.section.removeEventListener(CustomEvents.variantPickerSelected, this.handleVariantPickerSelected);
  }
  updateProductForm(newProductForm) {
    if (this.innerHTML !== newProductForm.innerHTML) {
      this.innerHTML = newProductForm.innerHTML;
    }
  }
  async handleSubmit(event) {
    var _a, _b, _c, _d, _e;
    event.preventDefault();
    if (!((_a = Theme == null ? void 0 : Theme.template) == null ? void 0 : _a.name)) {
      return;
    }
    const form = this.querySelector("form");
    if (!form) throw new Error("Product form element missing");
    const sectionsToUpdate = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:sections-to-update", { bubbles: true, detail: { sections: sectionsToUpdate } }));
    const formData = new FormData(form);
    formData.append("sections", sectionsToUpdate);
    const fetchCfg = fetchConfig("javascript", { body: formData });
    const { addToCartButton } = this.refs;
    if (addToCartButton) addToCartButton.setAttribute("loading", true);
    const buyButtons = this.querySelectorAll('.shopify-payment-button__button, [data-testid="Checkout-button"]');
    buyButtons.forEach((btn) => btn.setAttribute("disabled", "true"));
    let response;
    try {
      response = await fetch(Theme.routes.cart_add_url, {
        ...fetchCfg
      }).then((res) => res.json());
      const hasError = response.status === "error" || response.status === 422 || response.errors;
      const errorMessage = response.description || response.message || "Failed to add items to cart";
      if (hasError) {
        this.handleError(errorMessage);
      } else {
        __privateMethod(this, _ProductForm_instances, announceAdded_fn).call(this);
        __privateMethod(this, _ProductForm_instances, hideErrorNotification_fn).call(this);
      }
      const cartJson = await __privateMethod(this, _ProductForm_instances, fetchCartJson_fn).call(this);
      const itemCount = (cartJson == null ? void 0 : cartJson.item_count) ?? 0;
      const openDrawer = !hasError && (Theme == null ? void 0 : Theme.cart_type) !== "page" && (Theme == null ? void 0 : Theme.add_to_cart_auto_open_drawer) !== false;
      this.dispatchEvent(
        new CartAddEvent({}, (_b = response.id) == null ? void 0 : _b.toString(), {
          source: "product-form",
          itemCount,
          productId: this.dataset.productId,
          sections: response.sections || {},
          openDrawer
        })
      );
      if (Theme.template.name === "cart") {
        ((_c = this.quickViewDialog) == null ? void 0 : _c.refs.dialog.open) && await this.quickViewDialog.closeDialog();
        ((_d = this.searchDrawer) == null ? void 0 : _d.refs.dialog.open) && await this.searchDrawer.closeDialog();
        (_e = this.cartMain) == null ? void 0 : _e.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } catch (error) {
      if (!response || !(response.status === "error" || response.status === 422 || response.errors)) {
        this.handleError(error);
        throw error;
      }
    } finally {
      if (addToCartButton) addToCartButton.removeAttribute("loading");
      buyButtons.forEach((btn) => btn.removeAttribute("disabled"));
    }
  }
  handleError(error) {
    if (!error) return;
    if (this.dataset.productUrl) {
      const { addToCartError } = this.refs;
      if (addToCartError) {
        const notificationText = addToCartError.querySelector(".notification-text");
        notificationText.textContent = error;
        addToCartError.classList.remove("hidden");
      }
    } else {
      this.dispatchEvent(new ThemeAlertOpenEvent(error, "error"));
    }
  }
}
_ProductForm_instances = new WeakSet();
announceAdded_fn = function() {
  __privateMethod(this, _ProductForm_instances, setLiveRegionText_fn).call(this, "Added");
  setTimeout(() => __privateMethod(this, _ProductForm_instances, clearLiveRegionText_fn).call(this), 5e3);
};
hideErrorNotification_fn = function() {
  const { addToCartError } = this.refs;
  if (addToCartError) addToCartError.classList.add("hidden");
};
setLiveRegionText_fn = function(text) {
  const liveRegion = this.refs.liveRegion;
  liveRegion.textContent = text;
};
clearLiveRegionText_fn = function() {
  const liveRegion = this.refs.liveRegion;
  liveRegion.textContent = "";
};
fetchCartJson_fn = async function() {
  try {
    const res = await fetch(Theme.routes.cart_url + ".json", { headers: { Accept: "application/json" } });
    return res.ok ? res.json() : null;
  } catch {
    return null;
  }
};
if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}
export {
  ProductForm as P
};
